<template>
    <div id="tenant-select-box">
        <div
            class="tenant-select"
            v-show="!tenantSelectClickedStatus"
            @click="tenantSelectClicked"
        >
            <div>{{ trans('users.label.database') }}</div>
            <div>{{ databaseIdentInput.name }}</div>

            <div
                :class="[
                    'tenant-select__button--round',
                    { 'tenant-select--disabled': disabled },
                ]"
            >
                <img class="icon" :src="selectIconUrl" :alt="iconAlt" />
            </div>
        </div>

        <div
            class="tenant-search"
            v-show="tenantSelectClickedStatus"
            id="tenant-search"
        >
            <v-select
                v-model="databaseIdentInput"
                :options="tenants"
                :disabled="disabled"
                :clearable="false"
                @input="changeDatabase"
            >
                <div slot="no-options">
                    {{ trans('vue_select.no_options') }}
                </div>
                <template slot="selected-option" slot-scope="option">
                    {{ option.name }}
                </template>
            </v-select>

            <div
                class="tenant-search__button--round"
                @click="tenantSelectClicked"
            >
                <img class="icon" :src="searchIconUrl" :alt="iconAlt" />
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from './eventbus';
import { onClickOutside } from '../util/onClickOutside';

export default {
    props: ['tenants', 'selectedTenant', 'disabled'],

    data() {
        return {
            databaseIdentInput: this.tenants.find(item => {
                return item.value == this.selectedTenant;
            }),
            tenantSelectClickedStatus: false,
        };
    },

    methods: {
        changeDatabase() {
            axios
                .post('/api/change-tenant', {
                    ident: this.databaseIdentInput.value,
                })
                .then(() => {
                    EventBus.$emit('databaseChanged');
                    var swdemo =
                        this.selectedTenant == 'demo' ||
                        this.databaseIdentInput.value == 'demo';
                    var course_overview =
                        this.selectedTenant == 'sw001' ||
                        this.databaseIdentInput.value == 'sw001';
                    if (
                        location.pathname == this.route('dashboard') &&
                        (swdemo || course_overview)
                    ) {
                        window.history.go();
                    }
                });
        },

        tenantSelectClicked() {
            if (!this.disabled) {
                this.tenantSelectClickedStatus = !this
                    .tenantSelectClickedStatus;
            }
        },
    },

    computed: {
        selectIconUrl() {
            return `/images/icons/dbswitch.svg`;
        },

        searchIconUrl() {
            return `/images/icons/dbswitchsearch.svg`;
        },

        iconAlt() {
            return `database switch icon`;
        },
    },

    mounted() {
        onClickOutside(document.getElementById('tenant-select-box'), () => {
            this.tenantSelectClickedStatus = false;
        });
    },
};
</script>
